import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { DBVideoCategorySchema, VideoCategorySchema } from './schemas';

export const VideoCategoryCodecConfig: TransformerConfig<
  typeof VideoCategorySchema,
  typeof DBVideoCategorySchema
> = {
  name: 'VideoCategory',
  clientSchema: VideoCategorySchema,
  dbSchema: DBVideoCategorySchema,
  transformers: [],
};

export const encodeVideoCategoryToDb = createEncodeToDbFn(VideoCategoryCodecConfig);
export const decodeVideoCategoryFromDb = createDecodeFromDbFn(VideoCategoryCodecConfig);
